import { compose, display, spacing, styled } from '@material-ui/system';

const DirectImage = styled('img')(compose(spacing, display));

DirectImage.defaultProps = {
  display: 'block'
};

export default DirectImage;

// compose,
// borders,
// display,
// flexbox,
// palette,
// positions,
// shadows,
// sizing,
// spacing,
// typography
